import { render, staticRenderFns } from "./GlobalIndicatorsContent.vue?vue&type=template&id=6471e268&"
import script from "./GlobalIndicatorsContent.vue?vue&type=script&lang=ts&"
export * from "./GlobalIndicatorsContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports